import { f as formatMoney } from './currency-BS0riN3f.js';

/**
 * @class ProductAddOn
 * @extends HTMLElement
 * @description Handles the popular add on functionality.
 * @example <product-add-on class="block" data-product-id="{{ product.id }}" data-variant-id="{{ variant_id }}" data-cents="{{ variant_price }}"></product-add-on>
 */
class ProductAddOn extends HTMLElement {
  input = this.querySelector('input[type="checkbox"]');
  controller = new AbortController();

  connectedCallback() {
    this.input?.addEventListener('change', () => this.handleChange(), {
      signal: this.controller.signal,
    });
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  handleChange = () => {
    const item = {
      id: parseInt(this.dataset.variantId),
      quantity: 1,
      price: parseInt(this.dataset.cents),
    };
    this.input.checked ? this.addPopularAddOn(item) : this.removePopularAddOn(item);
  };

  addPopularAddOn(item) {
    publish(`product-add-on:add:${this.dataset.productId}`, item);
    this.classList.add('expanded');
  }

  removePopularAddOn(item) {
    publish(`product-add-on:remove:${this.dataset.productId}`, item);
    this.classList.remove('expanded');
  }
}

customElements.define('product-add-on', ProductAddOn);

/**
 * @class ProductAddOnType
 * @extends HTMLElement
 * @description Changes the variant and price of the parent popular add on.
 */
class ProductAddOnType extends HTMLElement {
  popularAddOnParent = this.closest('product-add-on');
  controller = new AbortController();

  connectedCallback() {
    // The parent popular add on is required to be present
    if (!this.popularAddOnParent) return;
    this.addEventListener('change', () => this.handleChange(), {
      signal: this.controller.signal,
    });
  }
  disconnectedCallback() {
    this.controller.abort();
  }

  handleChange = () => {
    // first remove the popular add on
    this.popularAddOnParent.removePopularAddOn({
      id: parseInt(this.popularAddOnParent.dataset.variantId),
      quantity: 1,
      price: parseInt(this.popularAddOnParent.dataset.cents),
    });

    // Now set the new selected product variant and price on the parent popular add on
    this.popularAddOnParent.setAttribute('data-variant-id', this.dataset.variantId);
    this.popularAddOnParent.setAttribute('data-cents', this.dataset.cents);
    this.popularAddOnParent.classList.add('expanded');

    // Update the price of the parent popular add on
    const variantPrice = this.popularAddOnParent.querySelector('[data-current-price]');
    if (variantPrice) {
      this.popularAddOnParent.querySelector('[data-current-price]').textContent = formatMoney(
        parseInt(this.dataset.cents),
        window.SHOP_MONEY_FORMAT
      );
    }

    // Set checked and dispatch change event to trigger the change handler
    const checkbox = this.popularAddOnParent.querySelector('input[type="checkbox"]');
    checkbox.checked = true;
    checkbox.dispatchEvent(new Event('change'));
  };
}

customElements.define('product-add-on-type', ProductAddOnType);
